export enum ERouteName {
  ABOUT = 'about',
  ABOUT_CAREERS = 'about-careers',
  ABOUT_CONTACT = 'about-contact',
  ABOUT_DELIVERY_POINTS = 'about-delivery-points',
  POLICY = 'policy',
  TERMS_OF_USE = 'terms-of-use',
  SEARCH = 'search',
  CART = 'cart',
  FAVORITES = 'favorites',
  CHECKOUT = 'checkout',
  FAQ = 'faq',
  USER = 'user',
  USER_ORDERS = 'user-orders',
  USER_SETTINGS = 'user-settings',
  USER_COMPANY = 'user-company',
  USER_COMPANIES = 'user-companies',
  USER_ACCOUNT = 'user-account',
  CATEGORY = 'category',
  CATEGORY_NOT_FOUND = 'category-not-found',
  PRODUCT = 'product',
  PRODUCT_LIST = 'product-list',
  SHOP = 'shop',
  PROMO = 'promo',
  PROMO_BLOGGERS = 'promo-bloggers',
  PROMO_PODELI = 'promo-podeli',
  PROMO_DOLYAME = 'promo-dolyame',
  PROMO_INSTALLMENT = 'promo-installment',
  MAIN = 'index',
  SALE = 'sale',
}
